export default __webpack_public_path__ + "static/media/add-square.e7e54ce5.svg";